import JraEncodeDecodeModule from './JraEncodeDecodeModule';

export default class JraCustomise extends JraEncodeDecodeModule {
  static CUSTOMISE_TOGGLE_EVENT = 'customiseToggleEvent';

  constructor(element, encodeDecodeKey) {
    super(encodeDecodeKey);

    this.element = element;

    this.initJraCustomise();
  }

  initJraCustomise() {
    const customiseMembershipOptions = [...this.element.querySelectorAll('[data-jra-form-customise-membership-type]')];
    customiseMembershipOptions.forEach((option) => {
      if (option.checked) {
        // ensure runs after stack so immediate listeners are added.
        setTimeout(() => this.toggleCustomisePaymentItems(option), 0);
      }
      option.addEventListener('change', () => this.toggleCustomisePaymentItems(option));
    });
  }

  toggleCustomisePaymentItems = (item) => {
    const itemKey = item.dataset.jraFormCustomiseMembershipType;
    const itemValue = item.dataset.jraFormCustomiseMembershipPrice;

    this.emit(JraCustomise.CUSTOMISE_TOGGLE_EVENT, { itemKey, itemValue });
  }
}
